const banLists = {
	isEnabled: {
		development: false,
		production: true,
	},

	data: {
		development: `
TCBZP1MiPCCyevfa31wKp3xQedwVa7Tdn4
TWEE5wJDL2EjR6iryH5mTyebDZWRbPZ733
`,

		production: `
PUyZycAjxGeMw1CCbHuZNEtRMXJ5p9e2oZ
PA5P3WJwMYdcovEECPDoDL6KCt6tyFcLHt
PFeHmHaz4Jfi636rrHMqaLBTwUkXJinaKB
PQfyBDp8iXcukhDGWKtLYLBKW14SVh3Vki
PMZUqC1VATs59sMQXx2b8caGXd57Bo8YzB
PLdFMd3PNpsZvb7bL7EfMRmc2mGSRoez6d
PC7VPRBoyAhzacU6pZPADkt6dxBHQTUaPb
PUMCHfbbBwT8wwDk6KAzqNvrwouZU7fDtK
PUHqLYZXDeULidJVxQMvG97d8LvZBT5a7D
PSPEnak9drfKQVxWYKuPvoRrFYF5pti5b9
PK8xnjAjCP6X64qE2GJgfrz9ybtWtUjqLF
PTqYN3cPLXuGbfyL5eN79exQdfj1dE15hL
PVn7vBNYJpGj6y8wcL1SLPFtTqkXmZyDsV
PQgMtUzDPeafZ9vn2UcE8TVAPiuCkppdax
PDoDFw1eM2z6Xm9ZpB3By93LvbsZ3UZqTR
PKAtf9ZMD2nEVi7PzKDDM5GPZoZ2Ah5DUH
PSGk67DDYtwyuYY1FFAF6sYoHySM5QtTgp
PKHA95CVbwVHjm7bti3AS1mraVdaxhETj4
PVMSXNyiNNH5ih9ps4iLjnRu6dPSmBVCAU
PF2NSQRzVGyY664XEy4iAJSqvRR4LDeYrY
PTPDjwXMRt2UHFtBhq65LNCmDSzXmWKHvx
PUe9vcWD9a9ux2TWVCPmc2jc19grbLaz5y
PLuydfDZkotmnG1YBbQaEpdNEbin9JKiYo
PJKffBh1sxDfLdE4wrBJ2io8zVVC2mLjwS
PMCtfirokEmkZDDjVxsqqrzySWeBRYc54F
PWwuBgywJBVqpExtGTRkhDZW6YA9To3DTR
PBBgzuEJQFk41CYu9u5KEbwSDVBTbo9ncn
PEd6TvM57WuB8B1VezZaajFDwGjWaoiQq6
PMz3Zz3FS4quUMt4jqMhLAQdDbkTeU22YU
P9qwjTo2jfnypf5pwp76oD6hQH6JnmUiiy
PJrruYqKEFL4LHNe9XSxWWtaCc3at5yXup
PM1VnAmm7Gna2KS3bYhsNJwAjX4xGSNdPf
PJ8Cqf13JF5TvNUtkq7gmUN4rYr7zioW8r
PAPkTJ8QaJdyVxmzzZpHPnQo7vWmcwd9YE
PDufoGwhD57xMvoBj8SvZ14Hc6WDoAtXiZ
PTvAqzm67snyqwnPQWM4WURsQsKsRJAJpS
PABDidTtRirYLZCcz7gbhRTyP55594ue3Z
PWuHpadwugPcb1MGAnMksL3VGQ94Yx3CMu
PQRyHBXuQzxnWTrJmp52JPLhZfNQr8EeJc
PLx8Pf8aBxaMsM2B8mAgsUFW9eb2gPoaWv
PW3iaWdcDKUvRiKjcs9VKmbEG72zz8f1Do
PM5NSCF4epRMinck7f9FabQsYZ5tyHasYw
PUGkh2eVfp3uUefRmWWMjXzxUWhzFRgFw5
PCo6Cks3ku9ayR2oovD9cKRLizoENNWjug
PNQvjS4LrMUcth3K8U65whW8QZznHf8ykn
P9ahcp1HhpWAaxqDHejEeQQDe2xQha2SZF
PXAtQuFPPnbPBr5bu5ybXKqbjfM121o9vZ
PU2BEjFmbEjAc9PnAcLZtJLQC3uqqAy3io
PFu1H8bcLA9BKSJhwBgF9ZLeGbM7cHHm2R
PQnMuHzJoCTBxrUEiA5pNjwoqHEoi4ffF1
PVYYcX8QaUugAMKUx9F1JuN4wv51T5eH8X
PP5r12ms5hbWkGRKM8uF6tH4KymNABLUpq
PRxDJox428Dx1n2gRBCspkjeoLeLaw2jWK
PANq8gfpSbnbH2gjg1SAPHaWMY97CJGVw3
PANq8gfpSbnbH2gjg1SAPHaWMY97CJGVw8
PFebzwkSSXZiKBFWavaHtLh8TRqiStrPAZ
PMYsyH1bRCFYvsmBvwLfUU6sQks1aawBiP
PLw5ijwPG9DmEqqqRNHtq2JkS8Jg22X6rS
PVSUaZUYSoNP71U5V4DXRxYN8y6ViGcLTb
PPbghkWKGoEjofq7WQC7565miTZWmWfRWG
PLTPzVn5ggdvbWCVayzHiKXMBGR3JuAHLq
PHztg1aHssbd25GPvhqWxtGHNGWr4tJ8gr
PTc2jfYhhj9FXrbgGhhJPdLgkAcxxaGe3p
PVj6RMT8YPySoJuQnLXoqQ81a4e9cxii7m
PF3n5fYdQwsYP3vc6MA43kk2epVUdTJdyD
PJJnRXRPVo4mNnY7sQDgKQ1jscb6cFU2C2
PAwxFxFPoVhDqj9agRVW1DrikFwGd5gaZX
PBC5vHacD4CQyG8u7ucK4k9G3WpUKnr81n
PTY5fk9m66tsCRWmsYxiAGe6tMvfNNYqBM
P9qsHJS3sUxxioSRMvzM3QnRhddyjiCsib
PKg6iH7MgteSkvGJvXdpWWUqJuR2Yz9N1M
PG9HMCYXL6ZPompJzacnUfTE82ZKLAi2pw
PGDv5NogAGV2bHxs8xQdDEn1qxbVSjXRiN
PNtyzqKeeWPs8pfsQs1ce2WfooXZ1JwE6F
PDGEbFWV4g5Pjn2Adc6tQpHrqTVEjcQ5kA
PJNbbrnnbHR2gA652E31e3ARYFkUkYZzgN
PB1JGcWGaRKJAXw7QqB4ueUgiWd67rAFfJ
PE7Fbdf2ydh8rvEXv9ez2PdNChYfzsZd8K
PB7mzvnvj7hnw64HiJrYEYvP4ArBhftGyn
PDMgTHxfBmX7cgsCNpzNHqTtsfy4HNNSie
PHuKK6RsckGUkF4Wo3BTCCgfWtS7TgH2yh
PFsQoEhypvAjhetr5bGuFSQE4KZKEQ1AgD
PWQ6N22KXHmk6phPhYomuAxa739X4RnESi
PV6FXXZiRj8enZLKE3KzdVZBM8GjXcJNgo
PCje3zKwMSfgsGTxtR42jNMzfcXt19HyJV
PMSfDm13sWxP53t2tUsiavmFA5QAuDjNVZ
PU9roUmPK58WZtnKKmnSWQHbXgKJ7hfM6K
PUFeEyYx6jx99HbzQNMF8udoXSzuCMmDK1
PE4aucPsDeNDe1SSe3ydT4P2NMmemsE7wd
P8rruaDGjTTnk4DjpTAMH1NY5GVVMtCUN1
PCWBX7TabjjKydFpfH8WmMDn8RTb3NJYGM
PNP7JJDHmsrUS4J7wxNRX36d9hDKkmDVRz
PEbGnpMbVFaqv6TfP4Rbf3tFsmfcNt3YQu
PWM1zgTzzQj4VqHvu23YJ3svaGTNoQrBmY
PGijcSwLBdSG2dXf2EhRaXyxX39PUPEk77
PWTQPwWtfQeb44UgGZw1upoJRtqwYAiow7
PUrt34SCL6xKBaHMqVYx14AGaXMUe1SVGS
PQAobkix96rRDk8wbjnMZqagfF5uWSq6bw
PRHLPiQ9NWnNmi3zqJiDF7TrpyvmEQkKH8
PBqFR5wXQL6aL8nGsSKqS2VBt5FRcMREBC
PS4ua1sc5pVy2GFVjefkUzsB19uv4MP4TN
PA43PMVZwEewzbkPZESh6AD6kwHLBCRW6F
PScsSKDQHifJm5ovygqMb4MGhjzWutUHzf
PTP4F1qUjMQRxQwBra9oEo13Z5x8gJpvbY
PBpLHZ9JoowWwHH7B2NaprJPy64LtUcgN8
PEsQVeMBTeD7mcPKP5qpKH182SKXDei4nV
PBiX7DADiPiogXRPaqhr857EYuxxWczpxP
PP8e1jK9fC9BYQZ4GP5oShWZmd3rKUd8s5
PGi6u4jbLkWaxFfgGdsSqJmtXYPNoMZmht
PFDVR49zHQsD4srgDpFRXdyyKUw2XrRjGX
PLcAd2kqgSXggXzgcXpmxEnfpswZNWjT6f
PTmr2v8BSnamt3dPP9TCuxTbXGFEr4pEiE
PGNGxS5DwR3yQtbmUhX5SEwa82wCoAd71Y
PCWsBSALWCfiEoGGzuvcFUh5uGVor81LML
PXrppHqHQcMXFfxMiHLgZkYCXPimMR9N1c
PFDS2Dbgi5tev8QmSPPDC1UWdEzvQJU21t
PJYW3DHF5ZqzeyGZAi4xFLrFiogF313mJ3
PNc3bekXk4WvGPC623LVcKwezVb6RN1dv2
PCtw89U6KkdBvDpEpBrDqxkVRbdQdbHixB
PASvH8evg1PATZqQwaRonRYh5rafk6mcEC
PTqpSvCNKEc6PYg7dHWaD1CLdVUhZJUGos
PBu5pmF3qbnHicXypVYBAwDvpthaLvg5Qx
PJsCFNoYv4FbmLyZKADGFRaYZi4vtUsSSS
PLAg3WTgWNGPTxXQifSDTrPFwNJFropQYq
PMPSdeLeAApUHmySvGL3vcXkBtzZgKBryv
PNcjksz7cb4xkXpHgor5hHthgG1wsVM8vH
PC8EDGraNnHHBiGq5wqPWQLK2eGnhC7ZvN
PSnqPLUiHYH7jWSLAhygf7o1byekCdAnFR
PHL9cJcRM4aSBsDM8BmTt8GArtrT8Gsvsc
PKep3kiZ2roMgGAsWoUHeNWFqhBEyCfdJK
PQcu8DTy6oyTjUQiVpg9fH2beVFiETscKn
PXLv32v46u6rySovKt6AcDFAYtJFqY8yDf
PPPdYfeeeABejEsUQ6rNm7t5zxMbwVWJVa
PBfbysupsb9RRMPrRPgJb7dU8eifepisxh
PGGvaFV1y2pZP32SmJjPnFiAHa6EcKEsRR
PVQKLNGMP8LHhv3wJioityGKRE8NzQ6jdc
PCBiiyfCuKSujKUWnaBcJyCsrGRjqzkC8v
PMKq2dLMxnFbWUiRWKjtESuLMwjzZZ1tVY
PMsiCiMgasYDtg5SBTh78E4Gc2AxFFqQPP
PAgETT93D13GzscghSHhDbe3vz3XkkEZqu
PSr3hpouGE6q6pBGKCeSGQXFUUWV1KdJU8
PPHHFRTnXeV1gM4NVj9H8D8KExqEHFDjJ9
PEHhNG1Zsr5YxJhUmJtat5FYe4q9BUBLRh
P8zMc6hKsCZsZT7cYmzRBVVkKZ7DMRocp6
PGaKpDQhzZiBQ15UYFxRe2Nmdz3HUnbd6Z
PMmvod4DxXSVu8SuQYAYgCxiRo5AJaSkz1
P9LPZQ6gvi93qqpnt5ZuFTwyxNHaj5C6hZ
PPp5R8HAKtrC5n7rTbEBonW2iVqfiki7La
PQ8FzM6GDF3WKEGA9BmQjjxGBY6ek2TiyA
PLXMufoTfpoAErfDRRTbVyqhRJcKmEF21G
PXA7B7bpDwFdqfjYDMAAmyEeppwVY4eEpX
PK91QHHBQgfZrXiqjCQ46gdxrg2yqMvgsU
PBRgPVx7kR2LpMmtUrrPAEBQa5Nmy8X432
PE1KUVripdaw7a9qjYHPXDrMijpmseRmEa
PACPV9yntqLARUi3116nhtBSYzcDwN8eRD
PTvqVsXhhC3Yq321Af5a7NHjdEBVu7Cx7k
PNyPjG2coYFLkzGftXubKzjGg2P3UJbrQW
PTG7ppwu1dAkd9jh7gTVwgiEo3gg4FjxVW
PA2gb4iPmqMzkJfqTw77xC6QVRPf1jJHcM
PMpxHMS4sKT4DWnQLnnPuLDrvU5GiG3K55
PQ4G6mz6PZxjWaNmt1Qr9hZegR5Bexw5mi
PHJ5LFMJW4hA5KUjZQhwF6pdvK5Rnef75u
PPhopYF3ai9soHjp3sk2Dgv5tfqCA4eWPn
PKG4mAGERgceXaMj24T35yW6bTxjQgRi8y
PR6ut1H3xmxLZHuWoskBczhFTvj72VNpaD
PFvykmTVcPVyfD9ywiPW8DVr1H3ecD3ezR
PUqZHt6yJ4ddBjEMRm8eVxeVbAbMdBwNhR
PCjc5mvPmMKpMp4f81KktvMhPAQqoED5mR
PGuVfHv2k2VxAmXHtGac2zGWkDPcJDo8R2
PWnvgUDSHkqXdsA4hKfQxAKReWaSuF2sps
PBQcNVNvxA7ch8WojfpDoDiPEer73r5frT
PGNQNH2K9LqN3FDo4kSH9gm6PGEAjgxDJf
PXtk9mnyR2z3qvtpuJ38YypBEirBGnuf9e
PLnAMQQDL2k3eVm3t8X5wjxH5vwppWnic6
PVkYz1odafc1dcqtpo8zsdsXo3HQEBypbC
PWJPFEoMd1zNVf5F6G5xcVdLVeisX8BKzi
PWCcQsz7EHnwKMun9c4vie9Lg3Nu8umxPH
PPVi5USnnBtFeWeszjvrs9BLjhqU66729v
PDqdREwoKvmX1k6RmqBgutt8wSvPRdApTS
PRigiDsvCFnC6WZ3hQ26VEYzRftu4JrUtA
PTYdvrdfvaMYtrtqijCH1tCJ2m2tVXhWiY
PFgKyT19sqKoAZZLdcWXjQLDYULgCqmoCm
PC5P5oxnai6W6X1L1KbdPDKbimf4FPbL5n
PGZmJ27jXLQi7BXkUGC2Kbyw3rF1uPK5gC
PA7k9TDTMSVz1vQKgyZfsVWtuefzmqnZyF
PNqUbKF9oqALYFM7UWjX4UQ5UapQJmUEyW
PKPZvWwkdMooR5HyyXNptAzaZAmc3cVtVV
PGFnfPpGhkxVLcqZ9fv6ka4LjDVC9zBqC7
PHv2gw36Z5Nct1Ah2AEV3m6bAyjMcfC6Z1
PKKHtaofBYgHpZbp6FTxnzXTchAGr1oKJC
PRbaAAgnpaCLyb8DCQx8peYYZJm9jduRUP
PBBQkdV2zCvwCqTNohtLAhRTW23N1hCDav
PGAMVfLienFsUX3D4mLwuMbDtBveQgLaHy
PDB59dVCikci3WxEqn8goNmfXULxzzqE75
PVBP6bjD95rgGs5aPd4FDoskUgC8vw7r9h
PAvo9qfk7583miP3MBtXvEbTcprbXAfVDU
PMsCFniHbnQT1sWTKnCWFhvQKUntQ6x5YM
PGLcek7UYsQhihnRZZa3kovc4ztpjcch3f
PB14yjbB1efq7PmuHoPAghgPMKDsDGdKuC
PRzxopmWLzQ7URnkjCDhjzHBSstJC2gjbS
PEDLsQGyjjS3Jx7oKRouKKCQvz3efHX1sA
P98EKdP6DrRnAuj8auFAYzb7sKFa6m4Wmj
PXQpZ5VHWYRZY3yuaDkh5Tj7Vz6L6NPFUq
PK1WCA7meJpjF27RxgiG7qYoNXqUdrYBvd
PF3TZzJhAw3Eb6uC1oeX5h9LR7iG4wDEDj
PXoWZgMRZLx4fDk75X6duWLFxJobpr2Jxv
PWgK3NKpT6hV3t9ApxyEGfLNLc1jXbiNbv
PMMeKqrtCnguj8Ghx2raQpXBrEHmChwpEK
PWCsX3SgGXxPbu6kjCj6s3FeHLeVjhDruK
PTQmRDdXHSpDswxm6zf71PabA1Y6njUWs1
PHcMtj5R9kkweQusDigCaAgnquBZWzb375
PPcTkWyMCcdGFVet1wrW7fWAaqnKg1QNRB
PLw5afn48bE8oq5TKNucLiVRCE7dvSXfSE
PRhvbWNLrtcWeSJjooJ45uYTM2xs7nUuVL
PECsrxS5LqgkrAQews13gtJ2oTBW9iwadj
PVQ3jWqv4hPoxHkqah2ctSFtL5XmWeeAdv
P8yRcyotWJsTFmeMQnFGKvR3drUEGhQUGG
PGJEVPNX6fDmrZUh4vq36xAM6P2jxxG2Ly
PSF9hjnb9ftfnd4HEd11uzSU8paZiuZjKm
PMZ8DnFSZtrTPfTMfp8jQD4DtHCN8rAe3i
PFWJe9WNsqZMyPs56otuN2PpGEyKqKGUhS
PRkNSDDkNJWRUoRqhecWwuQppubh1jsePZ
PMgJrtfodDndX9ZxErdtvzH1GVekt23L83
PEkMr8Fypzwbin57B5MwUfRvvCsds2CoNw
P8pxXmQXAqizEZckoJaH2jbH9xiRb6cQcH
PSMcVUMnwFgampGaPo5yw4Qm2tCG7zvzJZ
PRUmxw7qwy56Mjb3oQBgjbUEsDRDCaSyAE
PTt4FoHtCYzeqFgULZtnSMjX95cYPhZTra
PQo1KbXFmicN5feXSrVRxNAf4mzfgACivh
PK1iEJC1oXNocqtWwA9SNUeP2mfWn3F2PW
PJdRvwFiicdx39oM97GmwVxjnpbYPfr1Mq
PLnjji9u9N7yRUKNbsPjQCw9Hu87gesjf8
PAy3noEyZ8aZJVzu7mciiZYPyoDguKu9S7
PLy9raB2n6ocEjZBXR7H9AGPbxTA1QfXKr
PKFYfbTpZ6LZqXdq2Nzqs886kdPmUnS3kT
P9SXqez49YVyqhuD6wMzCg5QkmXzvbCf18
PXXUhwvdSvwT9FUu9kx5U8K1SE3XUmgHaZ
PU64cNC95SvjNyhis9QoFDrftRB4FvkizW
PLH983iKtMomVvv1t8nfekBGXmsevJ7Cpt
PT7wiFRiudHQLhM1NMKp8JL2zrnCXB4xnV
PSsJ5jr1xsDtCBswzZcjDjQ1kVWEjdjQQv
PWmEiKMnADrWcta98GeWJd3eKcGimFr5FL
PXEcJf88oRTDwZeFbRKfebNVnQRknpEGok
PRmN8gHTkMnLJ8k2AN2C8w577XNJZxBiWt
PMkDUdPofFinemwHforRbqpsuxqmtyjh3f
PCz5CBKUkxajJcZJuVTF6Jf4BWrPiTFFGk
PDcd1ZAHFpPzbkrYPgKwQa1w8ERsPhp4MW
PBbM9u8C5Mou6sm9qtAkxcGsG2D5XqiJmJ
PM2qfjj895Sa8UbXW4EQSGim7GqYQKnJ5u
PXKqsmMTbrddKYZ3tHZEBs2u44PrsRcbG3
PKqR1Razq17mj111VJzFJ8QHG1kr3stVk3
PJAr7xCQYqPiyWfCHCdhSm4fq1Ci73k4qx
PG6iv774ZpaGD9y8Rynqypvd1RMB5AYi5e
PWgShv6Hz7qA4qtADXWSDsziumrZ2TMnpd
PR6d128jX6qrG7aXtxaVsB4XJ9f1bjgyPN
PDaCdgdiM5D3q1PZtFJ5yrL2DRNkzGFpHf
PAdWk2FTKth5xX3XYCt16po4Svb9mnXuLT
PFfkgnfauWKdtMRERykF4YhXirSD5dx2hc
PPeiavEFA2T6oNVcT6VbjiQvz6XwWvwKWG
PN8evfWBraCpnEQqdguUnoT5pCpqwrU1ky
PU7i7CL6aM69so5NwR1fGsYFMAaBbpruGi
PWseYS5cdMXWp8PnduEPpbuQnpgFkhRbtY
PJwckD42sS13so42MsfbExebc8nzMCiy2L
PQHMuQf3mF6nBCASJuSPxTrPqdvoMRxNz1
PKW3RcUP24FJzKcrKPAZw42vSiQ35af6c9
PDVtwT2Vso9fD1zVcMtEZEE5C2J78knTVV
PEh8CwB3CKtYJSvTrBw1d5iiPBPFDWex5R
PGQLNwQzCXBTA2s3sJAJ9xBtvnbXYqdVnc
PAuJ9QhXJDaLz4izMZk9pZ5ZjKzCNgf67P
PJCeLWKiQZZ6EG1o7PrpD7GkPHUg9MxRhg
P929fY8MmbngJQjbCbXH1oQKupA3CMGrGo
PDGjRgRzh5MzQ4fEpCN3jCkRHUTUpybRiZ
PQLECsuHY3DxsdRDaHd5H5XfFCMwTdTxWR
PTUNuBfrPwoKD3SPYeu98ER7pRFvJE8UdC
PAu8SH2hXkiVNXyxeezhiAAA8C1Wh9eWDi
PFDc1Ep1PYFNzcUMAanzawwYABiRdE7Q7F
P8qmN8V3rSvszsASCCra3GXDmKyqRxJCfa
PG1bRv4og8sz1ypMVwVm5hNA2CWUe3xdKv
PVwJmNV1rk9g81Z8eEtdBwEnxq6EgfKdjS
PUEaZHFAU8Jk6DaPVovfBREmxEpqcnpFHt
PPPKkjoovTnMf9bJSSMFT2fJFcC5mcDZpC
PHiiqreRzXTSz1EXivYPUjnbA7UanXVbtf
P8dq1kX9pMy2j67Wpifcv9Sbz5wMumYgRG
PQ4cbKGH9uSLJxmCjPDksD2uNQUKsS3CcT
PH2yfvW3vfnaD6Q12V3FyZBadg2sWKoSCW
PN4zdk3ue9dSWigqFutFKhjZXZFKQuN1AL
PSMLV4Uz4Qvfbj6RRHeD86bDQmGM9VKxCX
PQvkRywUWEyJeT5m6Sg7z66ZLVM7Rz3LqL
PRqc7rzTeXfGgXWdKXrBBnUuCgBthtB84k
PMcXBx7wUfiLgBq4u97pHwwa8EnDhfcrFU
PBu42GpmuMLBK7fbhhgHPi9PhD5SgUByfB
PJugZd1CAxTLySL4WrtkoBMgnXhzctumec
PMhhkWS69iNYprQxiZWxeJB8CYiWjfFa2x
PPjD1XrJzzR3xet41VYBtVjL3vNKhUGfua
PKqBo69eoHz5vsyo9qGApZECoQG8swign3
PWNdzgvGK9vgsK4DJpsm4PvdwchMjyairT
PUeM68QztjRjqW3TUDGx8J94DpCmv8G5js
PSVbr84dfv7p5Lu4DUUZNigVhppkr7wybE
PDGHCGDFPigyxfHdWzCx8mt3PdzJ9ZBXo9
PJoW8VmZZwJWedYJPXSUh4nYNnsMj4Pko1
PV3cNSw67c1aMecrjbWqHuEjsEpvr6EbgE
PE9Mb174Zg3GuoCv7sN93qSYBRoGvc7mK8
PAUQEkGt8fn3wThenyV4xe3xeu2eWeV3pQ
PRM9UiDDe4vsHhhpFUFfGuC6u27RyC4dVP
PPhuCMQ4TG9rGWB1Wwquqzap8q4c2fi8nz
PDth2KR2uyWJHVNEBq84k9k32e9zJyCCr4
PQCtmKaX2Hb3gL8NHtRwM2gX2yMvXPw3C2
PFjtLiB2ckQiJPb9JcPEmEzz3DsGHE2Srf
PALbm4cbxNeDV8MwRjDFctFjRRqe8RfQzo
PEgytvXHWmCDmEAyxajMvRLQqaNhihrjbv
PLVjmgRTUDAJPPTa8DLzuPY8MJwAQeqzYN
PLfbAHGXL3wmgaMr6j3LWFbeQFKZKUXBuv
PXTPARCesErZui5AaoZkvhm8KLCfBDDGmq
PVNZ3SnjSFXL361XLfTX8tgPU6PYHAV7uL
PWousQi1Vt96voCvjEGRgT1kn5JqNV373i
P9Tv3ym837L6WZ42cWm3nSZWq7ik55bkTe
PNNhTEhE3bnX8ergh83ozKEScLZHe8BqsH
PAm7pYKxdkHiVXSQ6Jq5SQ4KTVf6dXe9Gb
PLwdffEMMkQoZcwR3U2J3Xnv26SW9jWL5b
PFLNRTdLua7Y9xT7BLbhLf1hg36aFbvFPb
PWgkc7cXi2QFGcXoaESM4xebf2qy4RoPgM
PHCvudQGFr95WpLzYXEfW7tst2zY1imgg3
PJHdfNwvLPRcMVjUdHpXLRgECzDai6m6pp
P9g2J44UgitqVFXamxVFjdy8bTZY86hFFG
PLQEd2zfgLS4m3rcThaBt2rVVQ2bVoNzDh
PG4YYF9ua1ZRTCmrabvpbR4r8D3FgpHGP3
PLiX7fxq84Zcgbs9E77G8gLkVtFS8qy5UN
PEiPSABiKcasXikm3Qc8yATVAULb4TaZFN
PLFfRtCSGouP619CP7qautf7nrMxRJxHt1
PS7MyXnFD4oSD7hn2p2mmLmsbTU1B4L9q5
PQ9bmrjTUi8BQGS3fo1rDVz57WpkxZNjsm
PLYvTnpuzCvmRRcP9AFMMxCnbmJL6oJQEW
PRkrxnGVQz11TzPvGY8X6fAvEyanV1jdw5
PRhMTqRTZTHSR9KWW81pfMsRCr9AukXaeM
PVsAxTVAwmai28gXvgfSVUnNtgmm1Z7YCk
PHb8um9STfEo7cMGwPC58MnFMCkScpoxKk
PWxQW8asuDGVmuwqoGEtFf5j1u2aCBad9z
PFecCJNqwxmefeDrNVyNAijBWHgHf1FpVk
PPM3RyE6qDeijQDpY4DJFoCk9HhJGXoSFz
PTG4sLbM9bxLp4wDfmsEdvdsQdEvkF7ArY
PJvDn9cnBZW8yhW4PpSir6e8tNEd7r9rLE
PPtVqdpQtgSY1uzFNLXMy35mYmiHrex1Ki
PSjLsPrZKbmTjXgSW8e68Qa3tj7rLj8ZMk
PENUN1RCreqBMG5EB5QLMuDHpHXND53sDo
PFfArdDXRZ9oRaLwYo4P8ZV8uEdys5Exhe
PMbkSfBW4vJ4esdJBTC6MHVT7Zr1cxT7tC
PN55bVtCMziNgveNiKbThHRHaqT8zDFsRq
PGsdd1dXZGgjaomxWWomhbY8eiUWwAcsKW
PSjLo6bur5U4XvQGbhj27t1x5JgB1xbmAT
PF2vRKSRtWj9djxwyZekBSzSMLJ8ZoymXm
PWT2Sxn6rvxH1E6r5Dq4x5bAPuBV1MdjkV
PLYhMBu5JxKWhzR4KRNiP9uoVS2yyRYvfV
P9qi4ESe6uyA2DjXExpAiXa45oRs6dnAZG
PQiZGCz3LJDAXUPmRKxP9hWoa89vpZBLSx
PJVP5n1jj5cFBtjyYvSzTqpMXY8ijLaiE8
PC6p27vf45vUXp3pxntFQJ6y4YA3Ph735N
PKHoM9FXGBbtEp8SyE7W36gwRvNzxZ2jit
PAK5ew2cNxqDLV3JrDXYexuHxv5tXssaeY
PP6oKBG4fdpgeGdKyhRhuCwQyqHPRTscfT
P9fP3UYVciMAaeNPXQkvCKuyZnJ3iLyxM9
PRRHqd4rLyT19DRi6t5u5dENpxoJErDXrX
PNCsxd4m8HBQRdSrfFyzEFsQDdEwaCdiBA
PPn5guh8pg5ZdL38z1pqWu324jj65VgmPE
PE3vmfbZSWFUd4beb8VzuXq2y7gRrG51d8
PPgDVVgaMoxHXSTHNFd4qYiRZoMX2fc1bL
PQGLhqgm7KjXHJxa3BE4g726iXSqMND9Qr
PXdAMJWsxk4gcA212mJM8ey181R3jEKR3N
PXsYPcuav6GMJBrgXb7xvaxpa7A8uvRkT5
PPqPhHSJY1Nfi8tA8HxqAVUKZiitsc5Trn
P8cbiRkyQsJikNgRY7JQMtyGpdjXdxxVkm
PFjtpxFYykY5KkVJ5j4PdksZP1SN3n7Zh8
PDRR5sn85kUxBdwPfUoeyw8tjcU2W5kCAn
PQ8Q1eB9YwnSJDuPWeZsFdEDXLzzyjDN19
PV8ushpGSPuoyBR8yKrg7uAvfdYkL3ht57
PU9g4jW7qfS5mrp998PHVD7E2VJTc9kJBb
PGKgafZURZLKZtHMRjfMT4Wu8x4hqB9h7i
PBeu1kAAdivydeY51xWkifPSGszED3PDyV
PJgHhJurK4H4Akd65K2BRF1aYbnzKEesuX
PKdkgpr6p38PqZnvtgsH7NA4tyNzUW7TFs
PUxbyv2GmtZVxNSnr3tMN5fxFCGnguezxf
PVexc2bYR9RKHXd9JfrR11R7vDT7o4ZipV
PX9gMwBQQJ619tiA2ZB5to4BTQcABoHmEg
PLR4myvweCEWbh5S1G4A3HLUKE44kCUoNZ
PUJog77ihZGs4W18ggMD7tJLr4PmDivkMV
PHAzP258TUbeQDSCeVD8N6EYvyRNoHsRTZ
PPPCE9stJKfPAJsp3UUEBCCjbb5qm6KHRK
PMNtZqNoyEHTTEBkh9mk8m2RZGUYr2K2c1
PMwH51o2YxfZLChSqsbr9a1UUzvYJKB42G
P8rXFdX7amsyKyfLjLd5hZ8SM5sfixtSLK
PPj2ZR5HSJ5gUTb4ntbi67uNpvDa7uEcc9
PX9mP9c4cd3rDy98Rfor91nfXJEPCdBXJi
PJXh1G6eoyM5rjQRvLS1YjY6FseHCVfRAs
PWouA2TjdnV6r9ncXriVsQw5b6gUEt4uLB
PKUTQonzN4SHKiofPtv3z9W97ygKY68RWQ
PMzcbtcMnDCmpMbvLXdN9ZecZi1K7EH2mN
PAx5bBtkqWLjBC8sVGcbumEV3ig8o4gA4a
PTwDzArkstPPRkycj3Kti4XZBzMUPffxVG
PCwPNbAErgGbpsW2ZzgouwqBk6gLbn4SaU
PSNS8YTTqhQiKRhDRRPFPmjwigfiZyXdfK
PD7sRze4Q4wN6Pq4edKZUvXeAhGcdbC8NA
PD9D48uSEbrqFyqsPisnkvYPC3tUGe4Exk
PSJYdwv8FSMmvXBqtE6HzNFUc8fuCLzvoi
PBtfJuHK2xpsAQ5QvvnGqVoGznPq8MMBTb
PQ8aS42eeEE1kx5bXTNwyGPrAXzBkUPwKL
P9LJgyJBRg8aTfF9rM3UoDj24L6DK3Wd1J
PSXHgUCw44ttz2v8UM12RkjCftJPHzMqr5
PPC4CG8bLrqaSxRhvzVW6ciXeBHbczPduE
P8tu8dR2RgaPqM3VNKHJWziDVtwxwseruJ
PKfrjEebUXoE5hosYK1KATW8F15isenbrS
PAn9hzZhnihe6i1gBCtXSLjYcMD11rC4tW
PDT3Pm7rCA9rK4qxaNNg3Hatp6hYhNxUrM
PLRp7A6w5nzbJyuZWvRNhvi39WeTWXCHi3
PEyhDM3xpnysLd2p7iwhHod5GsFdu5FQTz
PTugZKPKZ4JXPxdqBKiP2AB5tFL3ZejUAF
PLV4GGThF2i5DNNXjRcMHc8mCSDmHw4LAF
PF2McacatYYMeSrdjr78nP9PLDk1r2xzRs
P9P7NrrqNjB4m2ummAnnFEGPFzeixE3ijN
PKwbX1HKzEV2nbGYta8cxS7nSEaBEL8YRw
PJE5NPmCFjrV6Har7xkLWaFFEdNFg3G5BE
PHJjd4H52Jk8cSQZ3NucC5JsVqtmiew33s
PJp7QvXGpCxPtSSwgYAJUwXH7Ti5T4tjzZ
P8y34J9HA5TZd25EaLvkovHjpNnjZMjRNZ
PV3R1mmshrsJJ8qjN3qGdhdPhXQ4azi9E1
P97QRJq3WJuQaEr9aXUBo8ab9947keR89L
PQ3pMLkG6mHBAdQcrKzfxSzZjgi5NWVKvF
PAXwvAGA8KTwqAjB8CX2wcY5zCLK2DjBvk
PDHkageC1Hnf35Ur86QsJMCzaDstttcZuK
PFp6KAgvGgbe11Cpj6nYpiMb7LAvmC9ySA
P9qT2KZqMHpAUzp4ggF29CQbSdv3ooscc6
PM2nWLV2ivHVKnXisE9kQupiattqYJjspM
PAKpfpsLAVtDHro6nbhez66wKDu9DFcjp4
PRH8j4TbmNwEgUTBkRVgR6AKYBWckmrxgt
PMP8F4iDMpgRpUe69hE9punsR2qgc1H812
PEi22q3zicvZFqa325kBkrKrd7NnoZw6UH
PA4aozoxtxvGspq64zyTHYgxWDjfp8jE8m
PTGHuQs4kbCvr2pUEX9yHTDVRkymmKHPWT
PMBqJUt3PbJqCmAHqQ5UNJzihncEg2wUp3
PPCEAm7iRub5grk3AznD1TVRG9LWcJejqw
PPqkigXtuQGzCcCDJoXBRYwJuWZqymqb6v
PXHC4FUNnwWGzu29118NX6naSw6DHZZE1p
PSCJJrxcG6kLxiNP8yPsB2peuYemTi23yc
PLKSbdt91H2Uzv97MVm6e3CwLNf9kxx77Q
PDZdf3tqJ33ecinyN6JGSdAb9shfhMpHwn
PVJy6dM1gPLnHXTsGS78nHybjZVjv4XCge
PEeAGww8ATcm9JnnCtFQn9vGiYPeVzAQXr
PEsUcYiZhpFcMLQojtjpb4eFv7GazTbP2f
PJZyXi3muNYQ6SqSHwPtLAzKDsbVdKDm8u
PVcL7m5Uc4Uhvegw8LFHiWJX8ViQUXSm2S
PABptoawCuarveAAYGSgBhUrFbcGuQt9b7
PRoCoPNUtnyLMu8ejPYtJYgXXhjSaC2rr3
PTcB9inGZxueeffu5SpwPqjqcYAxAPDLGS
PM3MHgTiJYmpvhW3xdXjWh2HiNkYMdXZgD
PJ794KE9u7kkcZiV4JXThs8Cq9SDhPwEhh
P94mK2qNjUjoSvXBhzbYdLQBLS3HHPZb5w
PKP6thH6YGEX63kMC7S9jgnWGB9SnyodWe
PNYfLTakBDSXSJiexbYfTRD1bjLTHpDguC
PXF11g3YkMcezuG8S2EWGVM191A4NzveG7
PKiv6gmscexhUJcNKefreZv59KAmc643KB
PT5ZKS5nehKzF2n5oiM1jmJCfJ8kd8FpKd
PVxbuKrRaMJRdwM6BmYBR8Q2DcJEZ8msuB
PLmM8rBzAjA6dcMZmi69GwjWbzN3U3A6sZ
PLs7Wgi1SeNUoZVfNKHUwTAeHyMUUCcEnj
PJG5bkvWvyEjPLkgfEvVtZUS7NbEq5zK1G
P9KbMmswrobW5ZXw4wsb9UmNBeQbjCX3yJ
PRfVtkpGF8bpafmwa1zdy4EHBKTTmYSEod
PSkFkQCyvxnc4SGh57cDH36XA7XtBeNnaK
PHquksmmEv6Ms7Vpk2BRVNHb5CA6wHfJnV
PE5psjRQSg6ekk3QskjnSW5s7Lt4Jv4V5B
PPh5PBSb3jC3AXJjD62vsmT51bRyerLMsH
PJHFkasx4yHX9WEbAQ5i7jh75MkvwkVPxu
PWwuHF4Zh62fwHW9CKkHQfHy6zqoM7fBxE
PAQSPf8pWKcqQmf7QdP88iKsCV8DDwkjch
PCwVaeLBgBFoLXPZGZpovtCe3dMECu13Bz
PWPMqkE7Dv1o29Fuz6EVLDQzFTzqZ3vLhA
PQ3QvBU6bFQfyTiJLHR6UPZWi8vSKW3xx4
PQGjZrj4RCEjsxAC8y99qPQN2LkNjsmkH1
PNn5xbRfeejSExb3UteQHVozW2BQoYWEko
PVnbuBrBAUxdDCbo7LZCVCyaToSeyzD8YH
PJxcTaFKWLUdUGDwMAQDgN9c1wyuCHFksA
PUSdqaHhGveJsRh6zMPu4uQiU66ob4uCHK
PE6B84cYKsAcdgjC1bhQPbjsy6ohfT865R
PT8F71ZaoeApkHAnpUq4eHiwEtV1tKHg2s
PXXVkU9RMZFCy9N2xDnko1cmptyctGWJM5
PGmmuUHfUAtm7YikVxEzQyyA576j8aWKVE
PPjZmYDQNoaMuJh3ZqoGA8o55qW2892b2T
PTWyBTykmUeBuvffaVVWfPKgQiLNPgaHTF
PWr8aJLFEwh9Sa6LofzXaRkzPCKRHD2mz2
PUu8gkcqrAiJqNSoi4XioFv8gSJTZCG893
PMETgo6QWSrpxi5VGGcUskctJi78ggv8JR
PFXg7akUiArTLTrVVxY3S4YiXrr6Gg9ox5
PHoLpLRgcwzGySuFf9C1iHdP23Pf8ftnsv
PDsVV4aCH3R63R6arjcR5o2WaN23s8GHHW
PLfNcQFYSrKUDf7n7Uusa4Z3nf22HXn8DP
PS1kmFpqKoxHva1wnrj38omLUG2i8arQ6d
PS4EH5hmyf6DyQLsmUehk5au5uySvB6wwp
PBZA65kWxjkTqKktLr6C8KyQm64qPbgq9L
PLxZqxnAqkukB49M8CUMR7AEcBw3hVGSWK
PH2EpmbbEtgHR8R2pqa7KjUADhESVGNDWh
PSxPv8d9v4NyQzHUVguzoCtKSUD9vpKo16
PDyPz8UTqUJZtD9GYiXk6EvQSKcQRg1EAv
PMktJYB8RpAiKeskxtfVAqA5iKMCUiVjpz
PBNuoByMuG5ap8m6isKuQ8mUQuaQmzdSqU
PBwS3rBXbDzQ7ZtHTf8sCt2zWBAukBN4q6
PFaT5h1cqizgEPtwRqqfqHpbgTL4mwWYTY
PTvJf7RoEJpL7w3HMNN3XJVung6VcxCfTr
PDqeSQGrTfuHoPWs3dGmgg5f6LDceVhVMf
PLeQfc4QiaqHhqxH8KwYtZpfQHSNyow3N5
PH1qdg9VCiiTENu4jM4GaxtMm7bb44M1JG
PRGpRh6LPQrkt8ijVjcaapiW13GoFDhGVF
PAXEQr6TrWTrGv3H98KhYK5epGwXYh9jGF
PUGHJK345B8ZsSbPAGXPVWN2VmBmj5X4Xt
PGUSdfwQeJhdXBKZSgsQfUdtkxR3gvgx2E
PMMTh7B3UfMReBJqstW73VqtBNQmkJQj9v
PNyMtqX9QcXciscMvuyUvrdgAARbpA5Hvk
PCu84rUb27CAHmtQwXGCpekhLyNkFHU6ez
PGDEGNijDnT4oqCJ7c6KCUQSD9efsP6gVy
PUUK7Q9cabVXadUvqyrdrjV1G6stPghohC
PTpS13zK5eK8yMMyEu2HkRnPJt6jD4B7g4
PKq9Vjj7JfRhLWMjt6mDp7h63Y8SmhHb1n
PUTiVE28oJ4nFgc5WYnL8M3PCVvsE2KimF
PAbUkksh8aq13UeAizY5UhoGWEKUsGEjeG
PH9NKuTn1GRjRaPdf8QqqwU4yEGEj3BHNm
PAGzmi8bDyVQC9fXN7pv8CsZ1kb6Yxd8nL
PPNpC4bsMKm2Ar8fA2ZkF9hfXSxSbGnCJ4
PKiY3zNBf1mHtsuLWavgS6V7aPJVQphrTY
PSC8hMVCEfBBEkztKtTqr89LMBN36jvPjG
PLaBMGkC9s9e4ZfaSiGSf4MBhwKH87kDYA
PPY2phwXmrASEDFk1jwGuMkUvnCEychawD
PRw7upDgSbosLbhfXrNjN3oWAii8m4UBV7
PBNP3ejct2Mc1Y6MHyTFvWM8urMwcR3sLX
PBGqFQZtnm7jr1Hp9ZjMpkpwtXpAUjs7Aw
PDCxXMTT53fVMkeZVyXNcSDxz54LMdmkGk
PJsLmcDE2gLdHkNZMnR2yjSM9f85U9PKHh
PWvKYK7YCk3HogqfpDpZ9cWJFGFp5MhmyL
PBbEmgJotQdZKBDXyMPz6TH2mT4RLpFK85
PLoS6zaynFAvtuEYLZDiZjDEFGUq8tHkQy
PEw7H3m39Xqn7rzoH93ZobG3k4XDQ5w2EE
PXCsrwEkyucFk9PqSksjX9Myu7Svo6AZv5
PHQRfH9DhRiEsoP2NmnRiZmbuqjjUxWXsc
PGVEcyfu4qJH3HNNAd9QobuLte5ZoH8qSy
PAZirYXxBfyGU7dL67AmF8wgTgvF6sFQHW
PJque6LXMv4ZFQbY173nkUwPJMeTvhnoFE
PLJjySydbXhoYrp4oKaLAvE9GrUbFKwRoj
PLKp2tQWgTgadYBYvBFoesMgTxFrDG5Q1L
PVEzbUGJ2hUkcQxo6uG3Ppxd3BdnzKgNqT
PJw8z6bDu38G58GHhDav5xfZPEmHDVQN3M
PX1BLkXkuEuiVTTPLcrxhoTrGHvHs4kn8x
PMwMEWtSRX92GyrVcBhszof6hfv4P61CUy
PWdP6uUn16bvaRHezbi7RyTFmwZFR9Xuqb
PVft9gZ9roFo6FZD9NBxsEjbo8VZKzezLJ
PVqV7SdYSXCDunw4Nud9e7eqg6NRtVwzie
PDfcUQ6dAZo29QkGWMGRKS8xw3xZrc3NZi
PCi9XuuQD8jkDLrhmv38GKZkJKpebsMSSw
PAYcyGhiM7F61TQcuktqGmG1YPAD9HZet4
PQdzy6ktg42xPdTFKG5fmvoCbEnWhDDX2o
PQnGNsAqNFuCegsexzYX53KcEUERNbijr1
PJ3E7HcB8s6c7MHH9aDPEYz8H8VFH9LvW1
P9axxNFm37RZxfJp3GXpCZcG9FgVz1D91B
P9nU5BxUoXbKuAyzWMN37ZMngHBPMKcbaw
PL2Xjp5XR4mkKiebgti8V5Apk2gRRJ98Kf
PWHMB2oE8sm5874Q9kjoLocbDW598dQX4e
PUYyzqptqkUGLePLy6eoyrFnfRjmMvyJgs
PQwuA5YNTtGBKkNhTbzJcAA2f3DbcTvoxP
PW1F8butdcFfHqrapPpcwneGzNeKwghuud
PP1LmVQtVGpeNeV3h2FZBeUcFWxfawqiHF
PJt5w1WdfttBe7muMaVkAHwv7EJf1jSrtW
PLXDcHguUW7NpMFcrvSh2KKoBNnHYcmFqj
PD5gLZhCJxtYs2j1P3pRdV7Xj8E3mEcNVb
PVCymLByfSrhTD7Y7eYUVFvU7MkCz35g6R
PCz1J47bNgGcAompyjmgZ6Jfj93bbL21mS
PTY7VVu5g2159pqDZLi1qLMKBAVtMCDtxw
PUC7SQ5WppYaw7sRpssjdx6wf8Uyzc6gKJ
PBphj9GhcC5i4W8ST5TfSi56aJuDZFvt6r
PWKcs2eE2763kUJkoVEAAvtKV4P3N1hmBJ
PVwoVSYzB9aeoZgZ2E6bnjYsW9wBLW8qU3
PLQyUzwTEx4Jp8HQuUXikz8xitadonVnvU
PQo9PZ1pDsF1kvZMxe4yzyfWrjWKSXgUw5
PDQuJTAbZQWJjYFEy4N1waWBtdAsyXpkgf
PWk27sXzPV9yno584cuzdm7fV4goGuKWET
PWHm2duLXx11hsL7ocBtmh73PVDqT2Sipa
PLsZube5pFLNS5p2RWPygqUq61kqoiv2AD
PNjamiRuMQY9yteEfeAFJdc3P4M5bsGef5
PJkQk48ffj4eB9QK9hS1qWhkRpARxDrLEi
PC6BqrfboV4zrxg47afpADxHPJvuKmQ5Cw
PTFTdcCWPpsUKkabMpQ7jJFWpZTxRiVCJr
PXmdv6hBpz9WKxGAsTHqoCfcuvMaNpgXbL
PDAN3bVKidCVXTDqiJGQyGZZy5Zfx2VzWr
PP6J1JJK8BCwS7WGKaa4M9gH5nE9HxhGmu
P9HJn4W4mQ9M5tNGjey2WgVLbXnoWDEPrP
PDjwPZfbnPQKjungDixZ6FD7zZdYsc6QBW
PPFrhWVuKu5ofP4TxFWwVJSBF3mYUrMCi2
PPXDHPbz18a5y7mYeQ6eBsavuB4oxeWtz3
PBikogikwMapUVzhJbM5zGc58mTteUMR6E
PNVUU8fyTdA9FtoquSBtiHQfYVJCc1jWBo
PVboEDcmvxw5XTnTEBki6RLv6XDyyLysfx
PKBsqx5FxaTHvEnQ4yKurkYzTx8qpcefHG
PBgP88SzKobqBAJtxVuCuRF65ERC4A3CJQ
PJeLvbwgsHVgv5DZsTmWAYxFaWcayPAt4f
PEvfUgE3sNTNy3yRoHYMZV5FrwFwmQNGpr
PNfv9fjH945Q7ub8icFBXZ24dqLHUFwQWL
PWfai21EKnPrsok4FHcSAfvVeBVeuYh8SU
PSsPGp7jpxe8KGxkqZ6Fjgfs819M58tZCn
PPL9WfCTvgtdP7M3nUXMtHznhRwuACKEau
PATN2g1pAaLa99nuPqNiCrP5mh4YM9DcE9
PJ5v2v3o5pTMooBhv86hb5MsdLwAYm5Aks
PRJddsRtAuDMhm7a5FSxb4z5BeRgLQRuPc
PHrymMeJaDhdezv8v5m3DVYf79D37bvJR9
PSb5HHrfoo6osW2krfsadphPGiST8b8HkX
PC74dRtoWFp67Kd5KfURT6FkkaAvZjyBDD
PSPjzm1nBHbquim6jEuHdQyNNwcuVgJkUP
P9A7zajZZukKW49Khy54VPGjRq5udNQNRL
PMG4w3UV89WppuhbwLq5THHi57BTeFQb1e
PNETV32GT5eB8kUoFbdLEw5yrnX9UPhLKb
PMMfp7myWgVZbNnTJqtvZqMFNBu9BPaFxS
PRxDi41roi1PVtHJY7szz43XCEMhYCWpVW
PHJqwbU9bPz3KDe92komiAgS5Vxy4fJM15
PV5BKD9qzDVbhCFjWfcWfxft7vRko5iCRt
PUVAy71169bTbMZAvPitcei8nmNiShBWof
P9uK37AtX1FCAUBjDf5sSRHpkRHzLQZEqP
PEwWoTNUYGS2kb8N6eGqbtFXqxuc6tapnE
PP5FNLxjS8f69YqcVWTL6Kg8Y2No117Lre
PU7q8YCNuxjExFbHdTNfZXbtCPXvV3472u
PS6yMxchyBpujs3KSqStPf9472trEmLzmE
PSMc6vEtTVy41tsEzYsdwbxJ6bLhCV98iz
PGvjDvHU1icyCF4hGtJTLCJATmkWpadXB7
PDGVL4NdHFAtRYA278eyTV4YTRPupn6PAQ
PDySW2Zmuaa2UjKvt6KNBP3LUBRPz3PvT6
PM2ZbKNDYkKpwJzXM7TKxiqow952mqiZb9
PWXJyas47wnDp5ttUJJbC5EaMtuc6fmz9o
PRmdK2Am8qDfZpVxWm9MMBs3Fb9CKsa49F
PPVx2HK76fR4LuV2PRsXeQbxnED8xBkmTS
PKREu3a5SHvbhTPCRShENhjftjuTwvKTLJ
PFWkPByyuAkhda3qsa1qio9zVKNga1q4cN
PMfAndQ6n4heXgBbnRx18PyNfAn3Bopkw7
PTvs1ebPoLXF4ecnJGqZrqetBqH6U1pUeF
PKgXjVq6erBSou1ioucDqVR1JdfW791bFU
PJn8CkdZHW5KTABBccb9dukdoud2RpaQfu
PRvxbAvHXRVWJeHWbZZShushV1mdfoo6Dm
PWmMU4Gvs8yKpUT7wPSSaQRHqNKaQG3Xrt
PQXyoq3WvMP38JEoPJVnVovcHTmWPYy8gT
PRrCHptAZUTcHvt4nTwn6kSNq1Pgb5wmgH
PWHR4z4R9JLbw4Ve4JpS62v4MVAQud4boP
PPPz9DvvSzD8aAiy9MbHrnyzmzYv75QksM
PGXsaRajLqbfeupL3eMxoCmhSztcTy3PUG
PEtA3Ssy6UjtsPXUvcYdkx25zZfuRwHj55
PQyN9YszCCwYyePCvjCQNSUAgrEjhh1PBo
PW8D2rAd5rnWvYZGEt4A65DguH6fuYvmLG
PEeKsuqpFoC8oHZvqRcjwAULwzs67KLo1r
PL6Zo9cGrmHCWocBU547oHib1nG5mVcKdA
PK1SWqLHFSsMQXWw9NnihG8ZZLE7CByPBP
PLuSVDSRdoEymFrkT3wkPRfsyiN7TYKVJi
PCBHGWRDySA6mnQBm6qFj8H1hhPsvgMRwx
P9wrfsEfBPWZpzNNoQ1ffe7yheNFHGzKcY
PAJiAuPFTnS5kaMgr1GEmSAzg7J1kTC9Yp
PDTaztarhY5tRkEcV6xCqrCYvirco5KrWH
PJuf9H7JqeLRsZEKXvmQYcdoJQJ84f2QsS
PMGSurQvLYBw9BpBUCrrumtiofHedVvgF2
PKEVzuqdyVQihwh6DsMKiz24krkd1nC9ah
PUavjn8nk1D9z4A3qsmiYpoJYDkdcmvzwC
PGsC2c2v7Wfdax2ZYiFm9btBgYkEp58UZ6
PVeGUSFP4dStG2z5W8s8NZQddpdKSdbsXK
PCBuJ77tRHRsVN8qkZZTh25Fb27ZGeDYpj
PL7KNQ1h4eM3pd8TuJUrKjUJEPfvQWwz7Q
PPAiSRPBg46nX7MJPq4nqLtRRbmfFxVvkR
PWeBd8oGyKJqp4oS5FUzcTKbsmdiYrgoMk
PMSQNyT3dK8hN5wdoLPddbXbonDXdUvevj
PJAjGuJjaic9V9VwckGtoGp28ava4tDKES
PMy6viJ6EGDPAog6UUGCHJc3oYtHaLP5CE
PU8EB8Vrg7Mhj2yWZ2pzcwmQkteDuGZRWn
PWsDtheTBZiRJRrzzhKkmZQQTDe44wez47
PLRvhqNWe112NTqyGAPFp6wvFCEUfeB15Z
PRBbtAqeCGFeV366vSkprejb3BiWkF5vCu
PB3o67YDnQ4qRnkt9M36kGgur7MYhrWc68
PT13vMnD2GW1zNuwaA7Fi2idC9DDNy16Yq
PL7u4EmDcdVistUC37tFMQ7PjxieULAh9f
PR2AAXpwXjTuQr8f1djKRqLrr6idVRXCUB
PXTP321biGe1rpeo1ghzjjQcFRBf9M336d
PJPBvovppxjrp5FFUbNoT4AtzLpkUj96yU
PXnZF8NUCEWkc6fE4kYrDAu5q2HV9dvr8g
PUtKFrkuJMbXMmRQtQzU8JMbNgAbBmbS45
PV9TX82S6LHoSEAV6XbhChyGjijeGqSugD
PMECzjHXGJJ2phzyXY2WwBwp1mA9u47UJh
PRSAn4Q9q3HHjCBZbfDNfWdYoRR82s9fqj
P91pvFB2e2dGJrKFdczhU8t9qkg8ACdWMH
PBgkuh6tkP7M8S7GixnFfxYnhbGDjU154c
PKUNHL9Ru98idZ5HWoHWKYJXvYsM4uxoas
PV9oPRXVS1HZ7hr9T266Fm826mwyJmEq7P
PC8WMVXRofKD2k3dnG8qGH2C2oZ6sZwSzX
PQCpfRCKyTTmgKqP3R1xpHAnhfzeMcEqtf
PQZskyjxrewNwejeH2JGF1d2rC2kYUQvZJ
PLi4du1FsrJ6J8Z2iHnawcgwdUWbGeQg6g
`
	}
};

class BanProcessor {

	constructor() {
		const env = process.env.NODE_ENV;

		this.isEnabled = banLists.isEnabled[env];

		this.banList = {};
		if (this.isEnabled) {
			this.banList = (banLists.data[env] || '')
				.split("\n")
				.map(m => m.trim())
				.filter(f => f)
				.reduce((acc,value) => {
					acc[value] = true;
					return acc;
				}, {});
		};
	}

	filteredOffers(items) {
		let result = items;
		if (Array.isArray(items)) {
			const banList = this.banList;
			result = items.filter(f => f?.address ? !(banList[f.address]) : true);
		}
		return result;
	}

	isBannedAddress(address) {
		const key = address && String(address);
		return key ? this.banList[key] : false;
	}
}

const banProcessor = new BanProcessor();

export default banProcessor;
